<template>
   <div class="update_pwd_mask"  v-if="updatePwdShow">
    <el-card class="update_pwd">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">添加银行卡</span>
        </div>
        <el-form :label-position="labelPosition" label-width="80px" ref="fromUpdatePwd">
            <el-form-item label="银行类型">
                <el-input type="text" v-model="bankType" placeholder="请输入银行卡类型"></el-input>
            </el-form-item>
            <el-form-item label="银行账号">
                <el-input type="text" v-model="bankAccount" placeholder="请输入银行卡账号"></el-input>
            </el-form-item>
            <el-form-item label="银行卡号">
                <el-input type="text" v-model="bankNum" placeholder="请输入银行卡号"></el-input>
            </el-form-item>
            <el-button style="width:40%" type="primary" @click="submitForm('fromUpdatePwd')" :loading="loading">提交</el-button>
        </el-form>
        <span @click="boxColose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
    </el-card>
    </div>
</template>
<script>
    import $axios from '../../https/config'
    export default {
      props: ['updatePwdShow', 'bankId'],
      data () {
        return {
          labelPosition: 'right',
          addShowOk: this.addShow,
          loading: false,
          bankType: sessionStorage.getItem('bankType'),
          bankNum: sessionStorage.getItem('bankNum'),
          bankAccount: sessionStorage.getItem('bankAccount')
        }
      },
      computed: {
        updatePwdOk: function () {
          return this.updatePwdShow
        }
      },
      methods: {
        boxColose () {
          this.$emit('closeEditPwd', false)
        },
        submitForm (formData) {
          this.loading = true
          var _this = this
          var params = {
            bank_id: _this.bankId,
            bank_name: _this.bankType,
            bank_card: _this.bankNum,
            bank_account_name: _this.bankAccount
          }
          if (!_this.bankId) {
            params = {
              bank_name: _this.bankType,
              bank_card: _this.bankNum,
              bank_account_name: _this.bankAccount
            }
          }
          console.log(params)
          var url = '/bank/add'
          $axios.post(url, params, 'headers', function (res) {
            _this.loading = false
            if (res.resultStatus) {
              _this.$message({
                message: '编辑银行卡成功！',
                type: 'success'
              })
              _this.$emit('closeEditPwd', false)
            } else {
              _this.$message({
                message: '添加失败' + res.errorMessage,
                type: 'error'
              })
            }
          }, function (err) {
            _this.loading = false
            _this.$message({
              type: 'error',
              duration: 1000 * 5,
              message: '服务器异常，请稍后再试!' + err
            })
          })
        }
      }
    }
</script>
<style lang="scss">
  .update_pwd_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      .update_pwd {
          width: 400px;
          top: 20%;
          left: 50%;
          z-index: 101;
          margin-left: -200px;
          position: fixed;

          .el-card__header {
              padding: 10px
          }
          .el-card__body {
              padding: 20px 40px;
              .el-form-item {
                  width: 90%
              }
          }
      }
  }
</style> 


// WEBPACK FOOTER //
// src/page/financeMgr/puAddBank.vue